import { ListItem } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

interface SectionHeaderProps {
  label: string;
  hasTopMargin?: boolean;
}

export function SectionHeader(props: SectionHeaderProps) {
  const { label, hasTopMargin = false } = props;

  return (
    <ListItem
      sx={(theme) => ({
        paddingY: 2,
        paddingX: 4,
        marginTop: hasTopMargin ? 3 : 0,
        borderTop: hasTopMargin ? `1px solid ${theme.palette.divider}` : undefined,
        backgroundColor: theme.palette.background.page,
      })}
    >
      <Text
        semibold
        color="text.secondary"
        sx={{
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          fontSize: "0.6875rem",
        }}
        variant="caption"
      >
        {label}
      </Text>
    </ListItem>
  );
}
